const faqs = document.querySelectorAll('[id*="faq-"]');

faqs.forEach(function ({id}) {
    const element = document.getElementById(id);
    element.children[0].addEventListener('click', () => {
        toggleItem(id);
    });
});

function toggleItem(item) {
    document.getElementById(item).classList.toggle('collapsed');
}
